import { DownloadFileAPI } from '../../../api/genericLayout/DownloadFileAPI';

export class DownloadCommand {
    constructor(appName) {
        this.downloadFileApi = new DownloadFileAPI(appName);
    }

    downloadLayout(layout, successCallback, errorCallback) {
        const apiResult = this.downloadFileApi.downloadLayout(layout.id);
        apiResult.then(async (result) => {
            if (undefined !== successCallback) {
                successCallback(await result.blob(), `${layout.name}.ipublayout`);
            }
        }).catch((ex) => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a transferir o ficheiro.");
            }
        });
    }
}
